<template>
    <v-card light>
        <v-card-title>
            <h3>{{ product.name }}</h3>
        </v-card-title>
        <v-card-text>
            <v-layout row wrap>
                <v-flex xs12 sm6 md3>
                    <v-img :src="image.medium" v-for="image in product.image_urls" :key="image.medium" />
                </v-flex>
                <v-flex xs12 sm6 md9>
                    <p v-for="txt in product.explanations" :key="txt.statement">{{ txt.statement }}</p>
                    <template v-if="healthRating !== false">
                        <h5>Gezondheidsklasse:</h5>
                        <v-rating :value="healthRating" />
                    </template>
                    <template v-if="product.product_nutrients">
                        <h5>Voedingswaarde:</h5>
                        <v-list dense>
                            <v-list-tile v-for="nutrient in product.product_nutrients" :key="nutrient.code">
                                <v-list-tile-content>{{ nutrient.name }}:</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{ nutrient.value }} {{ nutrient.unit }}</v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </template>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        product: {
            type: Object,
            required: true,
        },
    },
    computed: {
        healthRating () {
            const rating = this.product.personal_health_score
            switch (rating) {
            case 'A': return 5
            case 'B1': return 4
            case 'B2': return 3
            case 'C1': return 2
            case 'C2': return 1
            }

            return false
        },
    },
}
</script>
